import { Controller } from '@hotwired/stimulus';

export default class ProfileCompletionController extends Controller {
  static targets = ['maritalRegime', 'maritalStatus', 'professionalSituation', 'profession', 'activitySector'];
  static values = { professionMapping: Object };

  connect() {
    this.allProfessionOptions = Array.from(this.professionTarget.options).map(function (opt) {
      return { value: opt.value, text: opt.text };
    });

    this.toggleMaritalRegime();
    this.filterProfessions();
    this.toggleActivitySector();

    this.maritalStatusTarget.addEventListener('change', this.toggleMaritalRegime.bind(this));
    this.professionalSituationTarget.addEventListener('change', this.onProfessionalSituationChange.bind(this));
    this.professionTarget.addEventListener('change', this.onProfessionChange.bind(this));
  }

  toggleMaritalRegime() {
    var isMarried = this.maritalStatusTarget.value === 'married';
    this.maritalRegimeTarget.disabled = !isMarried;
    if (!isMarried) {
      this.maritalRegimeTarget.value = '';
    }
  }

  onProfessionalSituationChange() {
    this.filterProfessions();
    this.toggleActivitySector();
  }

  onProfessionChange() {
    var professionValue = this.professionTarget.value;
    if (professionValue && this.professionMappingValue[professionValue]) {
      this.professionalSituationTarget.value = this.professionMappingValue[professionValue];
    }
    this.toggleActivitySector();
  }

  filterProfessions() {
    var selectedSituation = this.professionalSituationTarget.value;
    var mapping = this.professionMappingValue;
    var currentValue = this.professionTarget.value;
    var select = this.professionTarget;

    // Clear all options except the blank one
    while (select.options.length > 1) {
      select.remove(1);
    }

    // Re-add matching options
    var self = this;
    this.allProfessionOptions.forEach(function (opt) {
      if (opt.value === '') return; // skip blank option

      if (!selectedSituation || mapping[opt.value] === selectedSituation) {
        var option = document.createElement('option');
        option.value = opt.value;
        option.text = opt.text;
        if (opt.value === currentValue) {
          option.selected = true;
        }
        select.appendChild(option);
      }
    });

    // If current value no longer available, reset
    if (currentValue && !mapping[currentValue]) {
      select.value = '';
    }
    if (selectedSituation && currentValue && mapping[currentValue] !== selectedSituation) {
      select.value = '';
    }
  }

  toggleActivitySector() {
    var situation = this.professionalSituationTarget.value;
    var shouldDisable = !this.professionTarget.value || situation === 'student' || situation === 'inactive';
    this.activitySectorTarget.disabled = shouldDisable;
    if (shouldDisable) {
      this.activitySectorTarget.value = '';
    }
  }
}
